var parent = require('../../actual/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/instance/index-of.js
// module id = 3504
// module chunks = 25